import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Reusable media position. `src === null` renders a clearly labeled,
// easy-to-replace placeholder frame — real media drops in via project data.
export function MediaSlot({ label, src, ratio = "aspect-[16/10]", testId, className = "" }) {
  return (
    <div
      data-testid={testId}
      className={`relative overflow-hidden border border-white/10 bg-surface ${ratio} ${className}`}
    >
      {src ? (
        <img
          src={src}
          alt={label}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover"
        />
      ) : (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3">
          <div className="relative h-10 w-10 overflow-hidden border border-dashed border-white/20">
            <div
              className="absolute inset-y-0 w-1/2 bg-white/10"
              style={{ animation: "shimmer-slide 2.4s ease-in-out infinite" }}
            />
          </div>
          <p className="text-[10px] font-medium uppercase tracking-[0.4em] text-fog/70">{label}</p>
          <p className="text-xs text-fog/40">Media incoming</p>
        </div>
      )}
      <span className="absolute bottom-3 left-3 border border-white/15 bg-obsidian/70 px-2.5 py-1 text-[9px] uppercase tracking-[0.3em] text-fog backdrop-blur-md">
        {label}
      </span>
    </div>
  );
}

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10%" }}
      transition={{ duration: 1, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
